<template>
  <div class="contents">
    <!-- <div class="head_top" >

           <div class="titles">
            <h3>票号：{{item.piaonum}}</h3>
            <span>
               <el-button size="small" @click="xus">典当记录</el-button>
              <el-button size="small" @click="pus">评估记录</el-button>
            </span>
            
            <h3>建当日期：{{item.dates}}</h3>
          </div>
        </div> -->
    <div class="details" id="print">
      <div class="titles">
        <h3>票号：{{ item.piaonum }}</h3>
        <span>
          <el-button size="small" @click="xus">典当记录</el-button>
          <el-button size="small" @click="pus">评估记录</el-button>
        </span>

        <h3>建当日期：{{ item.dates }}</h3>
      </div>

      <table width="100%">
        <!-- 第一行表格 -->
        <tr height="50px">
          <td width="15%" class="vereist">*车主</td>
          <td>
            {{ item.name }}
          </td>
          <td width="15%" class="vereist">*车辆状态</td>
          <td>
            {{ item.radio }}
          </td>
          <td class="vereist">*身份证号</td>
          <td colspan="2">{{ item.IdCard }}</td>
        </tr>

        <!-- 第二行表格 -->
        <tr height="40px">
          <td class="vereist">*职业</td>
          <td colspan="4">
            {{ item.occuPation }}
          </td>
          <td class="vereist">*联系电话</td>
          <td>
            {{ item.tel }}
          </td>
        </tr>

        <!-- 第三行表格 -->
        <tr>
          <td rowspan="2">车贷详情</td>
          <td rowspan="2" class="vereist">*抵押债券人</td>
          <td rowspan="2">
            {{ item.creditor }}
          </td>
          <td class="vereist">车贷总额</td>
          <td width="15%">
            {{ item.price }}
          </td>
          <td class="vereist">*月供</td>
          <td>
            {{ item.repayment }}
          </td>
        </tr>

        <!-- 第四行表格 -->
        <tr>
          <td class="vereist">*车贷余额</td>
          <td>
            {{ item.remaining }}
          </td>
          <td class="vereist">剩余期数</td>
          <td>
            {{ item.RestPeriods }}
          </td>
        </tr>
      </table>

      <!-- 车辆信息 -->
      <table width="100%">
        <tr>
          <td rowspan="6" width="15%">车辆详情</td>
          <td width="20%" class="vereist">*购车总额</td>
          <td>
            {{ item.total }}
          </td>
          <td colspan="2" class="vereist">*发票价</td>
          <td>
            {{ item.invoiceCost }}
          </td>
        </tr>

        <tr>
          <td class="vereist">*过户次数</td>
          <td>
            {{ item.transferOwnership }}
          </td>
          <td colspan="2">品牌</td>
          <td>
            {{ item.brand }}
          </td>
        </tr>
        <tr>
          <td class="vereist">*车牌号码</td>
          <td>
            {{ item.plateNumber }}
          </td>
          <td colspan="2">型号</td>
          <td>
            {{ item.models }}
          </td>
        </tr>
        <tr>
          <td>发动机号</td>
          <td>
            {{ item.engineNumber }}
          </td>
          <td colspan="2">车架号</td>
          <td>
            {{ item.vin }}
          </td>
        </tr>
        <tr>
          <td>车身颜色</td>
          <td>
            {{ item.carColor }}
          </td>
          <td colspan="2">能源类型</td>
          <td>
            {{ item.radio2 }}
          </td>
        </tr>
        <tr>
          <td class="vereist">*注册日期</td>
          <td>
            {{ item.recordDate }}
          </td>
          <td colspan="2" class="vereist">*行驶里程/km</td>
          <td>
            {{ item.mileage }}
          </td>
        </tr>
      </table>

      <!-- 核对证件 -->
      <table width="100%">
        <tr>
          <td rowspan="4" width="15%">核对证件</td>
          <td width="15%">证件</td>
          <td>
            {{ item.checkList }}
          </td>
        </tr>
        <tr>
          <td class="vereist">*交强险到期日期</td>
          <td>
            {{ item.StrongRisk }}
          </td>
        </tr>
        <tr>
          <td class="vereist">*商业险到期日期</td>
          <td>
            {{ item.commercialInsurance }}
          </td>
        </tr>
        <tr>
          <td class="vereist">*违章未处理</td>
          <td>
            {{ item.IllegalProcessing }}
          </td>
        </tr>
      </table>

      <!-- 现实查验 -->
      <table width="100%">
        <tr>
          <td rowspan="5" width="15%">现场查验</td>
          <td width="15%" class="vereist">*1.是否事故车</td>
          <td width="17%">
            {{ item.radio1 }}
          </td>
          <td width="15%">2.外观</td>
          <td>
            {{ item.facade }}
          </td>
          <td rowspan="6" width="20%">
            <img class="carImg" src="@/assets/cars.png" alt="" />
          </td>
        </tr>
        <tr>
          <td>3.发动机</td>
          <td>
            {{ item.engine }}
          </td>
          <td>4.底盘</td>
          <td>
            {{ item.chassis }}
          </td>
        </tr>
        <tr>
          <td>5.冷却系统</td>
          <td>
            {{ item.coolingSystem }}
          </td>
          <td>6.电气系统</td>
          <td>
            {{ item.electricalSystem }}
          </td>
        </tr>
        <tr>
          <td>7.制动系统</td>
          <td>
            {{ item.brakingSystem }}
          </td>
          <td>8.试驾情况</td>
          <td>
            {{ item.testDrive }}
          </td>
        </tr>
        <tr>
          <td>9.内饰</td>
          <td>
            {{ item.trim }}
          </td>
          <td>10.能源余值</td>
          <td>
            {{ item.energy }}
          </td>
        </tr>
        <tr>
          <td>综合车况</td>
          <td colspan="4">
            {{ item.values == 1 ? "较差" : item.values == 2 ? "一般" : "好" }}
            <div class="vereist">
              *经办人意见：
              {{ item.opinion }}
            </div>
          </td>
        </tr>
      </table>

      <!-- 市场及第三方估值 -->
      <table width="100%">
        <tr>
          <td rowspan="4" width="15%">(制表日)市场及第三方估值</td>
          <td class="vereist" width="15%">*新车在售价（元）</td>
          <td>
            {{ item.NewCarPrice }}
          </td>
          <td class="vereist" width="10%">*保值率</td>
          <td>
            {{ item.keepValue }}
          </td>
          <td class="vereist">*客户借款期望值</td>
          <td width="15%">
            {{ item.expect }}
          </td>
        </tr>
        <tr>
          <td rowspan="3" class="vereist">*（第三方）转让过户参考价（取平均值）</td>
          <td colspan="2" class="vereist">
            *1.（车300）
            {{ item.vehicles }}
          </td>
          <td colspan="2" rowspan="3" class="vereist">
            *车辆余值 (二手市场价减去车辆负债减去违章)
          </td>
          <td rowspan="3">
            {{ item.residualValue }}
          </td>
        </tr>
        <tr>
          <td colspan="2" class="vereist">
            *2.（汽车之家）
            {{ item.atHm }}
          </td>
        </tr>
        <tr>
          <td colspan="2" class="vereist">待接入</td>
        </tr>
      </table>

      <!-- 价值反馈 -->
      <table width="100%">
        <tr>
          <td class="vereist">*当物估值</td>
          <td width="10%">
            {{ item.overallValuation }}
          </td>
          <td class="vereist">*折当率</td>
          <td>
            {{ item.FoldWhen }}
          </td>
          <td class="vereist">停车费</td>
          <td width="15%">
            {{ item.parkingFee }}
          </td>
        </tr>
        <tr height="50px">
          <td class="vereist">*典当金额</td>
          <td>
            {{ item.sum }}
          </td>
          <td class="vereist">*典当期限</td>
          <td colspan="1">{{ item.startDate }} 至 {{ item.DateClosed }}</td>
          <td class="vereist">典当天数</td>
          <td>
            {{ item.det }}
          </td>
        </tr>
        <tr>
          <td class="vereist">*典当综合费</td>
          <td colspan="3">{{ item.comprehensive }}</td>
          <td class="vereist">*利息</td>
          <td>{{ item.lx }}</td>
        </tr>
        <tr>
          <td>分期</td>
          <td colspan="5">{{ item.command + "期" }}</td>
        </tr>
        <tr height="80px">
          <td colspan="3">
            *经办人（署名）：
            {{ item.agent }}
          </td>
          <td colspan="3">
            *复核（署名）：
            {{ item.reviewer }}
          </td>
        </tr>
      </table>
    </div>
    <div class="btn_Print">
      <el-button type="primary" v-print="'#print'">打印</el-button>
    </div>

    <!-- 续当记录弹窗 -->
    <el-dialog title="典当记录" :visible.sync="dialogTabjl">
      <el-table :data="tablexus" border style="width: 100%">
        <el-table-column prop="stas" label="状态" width="100"> </el-table-column>
        <el-table-column prop="xuday" label="操作日期" width="120"> </el-table-column>
        <el-table-column prop="name" label="姓名" width="90"> </el-table-column>
        <el-table-column prop="ticketnumber" label="票号" width="130"> </el-table-column>
        <el-table-column prop="itemname" label="车牌号" width="140"> </el-table-column>
        <el-table-column prop="overdate" label="典当开始日" width="130"></el-table-column>
        <el-table-column prop="enddate" label="典当到期日" width="130"></el-table-column>
        <el-table-column prop="dday" label="天数" width="80"> </el-table-column>
        <el-table-column prop="pri" label="典当金额" width="80"> </el-table-column>
        <el-table-column prop="ytdy" label="逾期天数" width="80"> </el-table-column>
        <el-table-column prop="xupri" label="典当综合费" width="100"></el-table-column>
        <el-table-column prop="lx" label="利息" width="100"></el-table-column>
        <el-table-column prop="xuname" label="续当操作人" width="120"> </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 评估记录弹窗 -->
    <el-dialog title="评估记录" :visible.sync="dialogTabPg">
      <el-table :data="PugTab" border style="width: 100%">
        <el-table-column prop="state" label="状态" width="130"> </el-table-column>
        <el-table-column prop="piaonum" label="票号" width="130"> </el-table-column>
        <el-table-column prop="name" label="当户姓名" width="100"> </el-table-column>
        <el-table-column prop="plateNumber" label="车牌号" width="150"> </el-table-column>
        <el-table-column prop="sum" label="上次评估价格"> </el-table-column>
        <el-table-column prop="newPrice" label="本次评估价格"></el-table-column>
        <el-table-column prop="agent" label="评估人" width="100"> </el-table-column>
        <el-table-column prop="date" label="评估日期" width="140"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "CarDetail",
  data() {
    return {
      item: [],
      id: "",
      ACCESS_TOKEN: "",
      tablexus: [], //续当记录的数据
      dialogTabjl: false, //续当记录弹窗默认不显示
      dialogTabPg: false, //评估记录弹窗
      PugTab: [], //评估记录
    };
  },
  props: {
    // item:{
    //     type: Object,
    //     required:true
    // }
  },
  methods: {
    //续当记录
    xus() {
      this.dialogTabjl = !this.dialogTabjl;
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("yxus_record").where({ticketnumber:"${this.item.piaonum}"}).limit(1000).get()`,
        })
        .then((rj) => {
          rj.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
          this.tablexus = rj.data.data;
        });
    },
    //评估记录
    pus() {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("assess_record").where({piaonum:"${this.item.piaonum}"}).limit(1000).get()`,
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            res.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });

            this.PugTab = res.data.data;
            this.dialogTabPg = true;
          } else {
            this.$notify.error({
              title: "错误",
              message: "有点小问题哦，刷新一下",
            });
          }
        });
    },
    //续当记录结束

    //打印
    Print() {},
  },
  created() {
    this.id = this.$route.query.id;
    //  this.ACCESS_TOKEN = localStorage.getItem("ACCESS_TOKEN"); //ACCESS_TOKEN
    //获取到this.ACCESS_TOKEN
    this.getTokens();

    //获取当前登录的用户数据
    this.getUserToken();
  },
  mounted() {
    setTimeout(() => {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("car_data").doc("${this.id}").get()`,
        })
        .then((ref) => {
          if (ref.data.errcode == 0) {
            ref.data.data.forEach((element, index, array) => {
              array[index] = JSON.parse(element);
            });
            this.item = ref.data.data[0];
          } else {
            this.$notify.error({
              title: "错误提示",
              message: "密钥过期啦，请刷新页面",
            });
          }
        });
    }, 700);
  },
};
</script>

<style scoped>
table {
  border-collapse: collapse;
}
td {
  height: 35px;
  border: 1px solid black;
  box-shadow: 0 0 9px 0 #5a5a5a38;
  font-size: 15px;
  text-align: center;
}
.vereist {
  color: #ec0606;
}
.carImg {
  width: 100%;
}
.details {
  width: 90%;
  margin: 20px auto;
}
.head_top {
  width: 90%;
  height: 45px;
  background-color: #eeeeed;
  border: 1px solid #79797936;
  box-shadow: 0 0 9px 0 #00000044;
}
.titles {
  /* margin: 10px 0; */
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.titles h3 {
  margin: 0 0;
}
.contents {
  width: 60%;
  background-color: #ffffff;
  box-shadow: 0 0 9px 0 #00000044;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.btn_Print {
  /* margin-top: 15px; */
  display: flex;
  flex-direction: row;
  justify-content: center;
}
</style>
